import React from 'react';
import LinkyA11yWrapper from '../LinkA11yWrapper';
import { OnLinkDataLayerPushProps, OnLinkDataLayerPushPropsImpl } from 'lib/util/gtm-datalayer';

import WithButton, { WithButtonProps } from './WithButton';

const Button = ({
  linkField,
  srOnlyText,
  onClick,
  onGtmPush,
  editable = true,
  ...props
}: WithButtonProps): JSX.Element => {
  /**
   * Custom gtm push support for when we are not passed a link field
   */
  const onButtonClickHandler = (e: React.MouseEvent<HTMLElement>) => {
    // If we were passed a custom onClick event, call it
    if (onClick) {
      onClick(e);
    }
    // If we were passed a custom gtm push handler, and event propagation was not cancelled, then call it here
    if (!e.defaultPrevented && onGtmPush) {
      // This handler is only called when we have no linkfield or data layer info.
      // If the custom data layer push doesn't do anything and we have no linkfield,
      // no push occurs.
      onGtmPush(new OnLinkDataLayerPushPropsImpl(e, null));
    }
  };
  /**
   * Adds CTA as data layer component type if click is on a button
   */
  const onCtaGtmPushHandler = (pushProps: OnLinkDataLayerPushProps) => {
    if (pushProps.dataLayerInfo) {
      const myDataLayerInfo = pushProps.dataLayerInfo;
      myDataLayerInfo.componentType = myDataLayerInfo.componentType ?? 'CTA';
    }
    if (onGtmPush) {
      onGtmPush(pushProps);
    }
  };

  return (
    <>
      {/* JSS Link */}
      {linkField && (
        <LinkyA11yWrapper
          field={linkField}
          onClick={onClick}
          onGtmPush={onCtaGtmPushHandler}
          srOnlyText={srOnlyText}
          editable={editable}
          {...props}
        />
      )}
      {/* Button */}
      {!linkField && <button type="button" onClick={onButtonClickHandler} {...props} />}
    </>
  );
};

export default WithButton(Button);
